import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  Box,
  ButtonBase,
  Fade,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import useStyles from "./sidebar-item.style";
import { IconifyIcon, InlineIcon } from "@iconify/react";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";
import { BadgeType, renderBadge } from "oc/components/sidebar/badge-registry";

interface OcSidebarItemProps {
  id: string;
  label?: string;
  path: string;
  translation?: string;
  icon?: string | IconifyIcon | React.ReactNode;
  badge?: BadgeType;
  onMenuChange: (id: string) => void;
  narrowMenu?: boolean;
  narrowMenuIcon?: string | IconifyIcon;
  onChangeTemporaryDrawer?: (open: boolean) => void;
  narrowMenuOpened?: boolean;
}

export const OcSidebarItem: React.FC<OcSidebarItemProps> = ({
  id,
  label,
  path,
  translation,
  icon,
  badge,
  onMenuChange,
  narrowMenu,
  narrowMenuIcon,
  onChangeTemporaryDrawer,
  narrowMenuOpened,
}) => {
  const { t } = useTranslation();
  let match = useRouteMatch(path);
  let history = useHistory();
  let backgroundColor = match?.isExact ? "#cc0033" : "transparent";
  let menuLabel = t(translation) || label;
  const classes = useStyles({ backgroundColor });
  const isMobile = useOcIsMobile();

  const handleClick = () => {
    if (onChangeTemporaryDrawer) {
      onChangeTemporaryDrawer(false);
    }
    history.push(path);
  };

  return (
    <Box id={id} className={classes.link}>
      <ButtonBase
        onClick={handleClick}
        className={narrowMenu ? classes.link : classes.linkItem}
        style={{ backgroundColor: backgroundColor }}
        onFocus={() => { }}
      >
        <ListItem
          component="div"
          className={narrowMenu ? classes.link : classes.linkItem}
          onClick={() => onMenuChange(id)}
        >
          {icon && (narrowMenuOpened || isMobile) && (
            <Box minWidth="24px" maxWidth="24px">
              {typeof icon === "string" ||
                (typeof icon === "object" && icon !== null && "body" in icon) ? (
                <InlineIcon icon={icon as string | IconifyIcon} width="24px" />
              ) : React.isValidElement(icon) ? (
                icon
              ) : null}
            </Box>
          )}
          {narrowMenu &&
            narrowMenuIcon &&
            !narrowMenuOpened &&
            narrowMenuIcon !== undefined && (
              <Box minWidth="24px" maxWidth="24px">
                <Fade in={!!(narrowMenu && !narrowMenuOpened)} unmountOnExit>
                  <Box>
                    {narrowMenuIcon && (
                      <InlineIcon icon={narrowMenuIcon} width="24px" />
                    )}
                  </Box>
                </Fade>
              </Box>
            )}
          {!icon && !narrowMenu && (
            <Box width="24px" className={classes.emptyBox} />
          )}
          <Box marginLeft="16px" />
          <ListItemText>
            <Typography variant="body1" color="#fff">
              {menuLabel}
            </Typography>
          </ListItemText>
          {badge && <Box marginRight="28px">{renderBadge(badge)}</Box>}
        </ListItem>
      </ButtonBase>
    </Box>
  );
};

export default OcSidebarItem;
